import * as React from "react";
import {CustomProperty, Party, PaymentCard, resourcesHelper, MAIN_ANNUAL_PAYMENT_CARD} from "@falcon/services";
import {Link} from "react-router-dom";
import * as moment from "moment";

interface IProps {
    party: Party;
    policyNumber: string;
    annualMonthlyOptionCardExpired: boolean;
}

export class CardExpiryBanner extends React.Component<IProps> {

    public render() {
        return (
            <div id="cardExpiredBanner" className="banner">
                <img src={`/${resourcesHelper.THEME}/img/alert-red.svg`} alt="Red alert icon"/>
                <div className="banner-text font-weight-semi-bold">
                    {this.getCardExpiryWordingElement(this.findMainPaymentCard())}
                </div>
            </div>
        );
    }

    private getCardExpiryWordingElement = (mainPaymentCard: PaymentCard): JSX.Element => {
        let textElement: JSX.Element = <></>;
        const cardNumberObfuscated: string = mainPaymentCard.cardNumberObfuscated.split('******')[1];
        const linkComponent: JSX.Element =
            <Link onClick={() => this.setAnnualProduct()} to={`/dashboard/account/changeCard/${this.props.policyNumber}`} id="changeCard"
            aria-label={"Please change your payment card."}>Please change your payment card.</Link>

        if (this.props.annualMonthlyOptionCardExpired) {
            textElement = <>
                <div id={"card-expired"}>
                    Your card ending {cardNumberObfuscated} has expired.{' '}
                    {linkComponent}
                </div>
            </>
        } else if (!this.props.annualMonthlyOptionCardExpired) {
            textElement = <>
                <div id={"card-about-to-expire"}>
                    Your Visa ending in {cardNumberObfuscated} will expire in{' '}
                    {moment.monthsShort(mainPaymentCard.expiryMonth - 1)} {mainPaymentCard.expiryYear}.{' '}
                    {linkComponent}
                </div>
            </>
        }

        return textElement;
    }

    private setAnnualProduct = ():void => {
        window.sessionStorage.setItem("product", "annualMotor");
    }

    private findMainPaymentCard = (): PaymentCard => {
        for(const card of this.props.party.paymentCards) {
            if (this.isMainPaymentCard(card)) {
                return card;
            }
        }
        return this.props.party.paymentCards[0];
    }

    private isMainPaymentCard = (card : PaymentCard) => {
        const party: Party = this.props.party;
        const properties : CustomProperty[]  = party.customProperties!;

        for (const property of properties) {
            if (property.key === MAIN_ANNUAL_PAYMENT_CARD && Number(property.value) === card.id) {
                return true;
            }
        }
        return false;
    }
}



// WEBPACK FOOTER //
// ./src/components/banners/CardExpiryBanner.tsx